import axios from './axios';
import sessionsService, { LineupEntryInput } from './sessions';
import { Session, TimeSpan, Video, VideoValidationResult } from './sessionModels';

const URL = process.env.REACT_APP_PORTAL_URL;

export type ProbedVideoInfo = {
  encoding?: string | null;
  bitrate: number;
  fps: number;
  length: TimeSpan;
  width: number;
  height: number;
  validationResult?: VideoValidationResult | null;
};

export const probeVideo = (url: string, baseFps?: number | null): Promise<ProbedVideoInfo> =>
  axios.post(`${URL}/api/v1/videos/probe`, { url, baseFps: baseFps ?? null });

export const transcodeState = (video: Pick<Video, 'transcodeStatus'>) =>
  video.transcodeStatus?.state?.toUpperCase() ?? null;

export enum LineupReason {
  Substitution = 'SUBSTITUTION',
  RedCard = 'RED_CARD',
  Injury = 'INJURY',
}

export const saveLineup = async (sessionId: number | string, removedIds: number[], lineupEntries: LineupEntryInput[]) => {
  for (const id of removedIds) {
    await axios.delete(`${URL}/api/v1/sessions/${sessionId}/lineup-entries/${id}`);
  }
  if (lineupEntries.length > 0) {
    await sessionsService.upsertLineup(sessionId, lineupEntries);
  }
};
